import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

interface ItemObject {
  item: object
}

import draggable from 'vuedraggable'
import { defineProps, defineComponent } from 'vue'
import { DraggableEvent, isEmptyArray, generateIdByTimestamp } from '../../utils'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'ComponentList'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  itemList: {
    type: Object,
    required: true
  }
},
  setup(__props) {



const onMove = (e: DraggableEvent) => {
  if (e.from === e.to) return false
  return true
}
const cloneDog = (item: ItemObject) => {
  const newItem = JSON.parse(JSON.stringify(item.item))
  // newItem.id = String(++store.state.curItemId)
  newItem.id = generateIdByTimestamp()
  if (!isEmptyArray(newItem.attrs)) {
    for (let i = 0; i < newItem.length; i++) {
      // newItem.attrs[i].id = String(++store.state.curItemId)
      newItem.attrs[i].id = generateIdByTimestamp()
    }
  }
  return newItem
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_unref(draggable), {
    sort: false,
    list: __props.itemList,
    group: {name: 'itxst',pull:'clone', put: false },
    animation: "300",
    move: onMove,
    clone: cloneDog,
    "item-key": "id",
    class: "el-row"
  }, {
    item: _withCtx(({ element }) => [
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_el_image, _mergeProps(element, {
            key: element.id
          }), null, 16))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["list"]))
}
}

})